import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Kata Sandi"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, " Silahkan Masukkan Kata Sandi Anda ")
], -1)
const _hoisted_4 = { class: "row fv-row mb-7" }
const _hoisted_5 = { class: "col-xl-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Email", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "row fv-row mb-7" }
const _hoisted_10 = { class: "col-xl-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Nama Pengguna", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row fv-row mb-7" }
const _hoisted_15 = { class: "col-xl-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Password", -1)
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    id: "kt_sign_up_submit",
    type: "submit",
    class: "btn btn-lg btn-primary w-100 mb-5"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Konfirmasi ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        novalidate: "novalidate",
        onSubmit: _ctx.onSubmitRegister,
        id: "kt_login_signup_form",
        "validation-schema": _ctx.registration
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                placeholder: "Masukkan Email Anda",
                name: "email",
                autocomplete: "off",
                modelValue: _ctx.registerPass.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerPass.email) = $event)),
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ErrorMessage, { name: "email" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: "Masukkan username Anda",
                name: "username",
                autocomplete: "off",
                modelValue: _ctx.registerPass.username,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerPass.username) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_ErrorMessage, { name: "username" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg",
                type: "text",
                placeholder: "Masukkan Password Anda",
                name: "password",
                autocomplete: "off",
                modelValue: _ctx.registerPass.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerPass.password) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_ErrorMessage, { name: "password" })
                ])
              ])
            ])
          ]),
          _hoisted_19
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}